import React from "react";
import { LayoutGridIcon, PrinterIcon, ListChecksIcon, BoxIcon } from "lucide-react";
import { steps } from "../data/steps";
const stepIcons: BoxIcon[] = [LayoutGridIcon, PrinterIcon, ListChecksIcon];
export function HowItWorks() {
  return <section className="cube-grid relative border-t border-white/10 bg-navy-600" data-id="element-115" data-mp="3q02s4y2wk027">
      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-14 sm:px-6 sm:py-16 lg:py-20" data-id="element-116" data-mp="3u0v1drbry4yh">
        <div className="max-w-2xl" data-id="element-117" data-mp="lll3kvex3lwi">
          <h2 className="text-2xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-118" data-mp="lmmemzvxo8e8">
            Print. Play. Track. Repeat.
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-119" data-mp="csrkemwco2dd">
            Every session begins with a clear challenge, a visual way to work
            through it, and a reason to keep going.
          </p>
        </div>

        <ol className="relative mt-9 grid gap-5 sm:mt-11 sm:grid-cols-3 sm:gap-4" data-id="element-120" data-mp="14humpx4of2nd">
          {/* Connector rail */}
          <span aria-hidden="true" className="pointer-events-none absolute left-[26px] top-6 bottom-6 w-[2px] bg-brand-emerald/25 sm:left-6 sm:right-6 sm:top-[26px] sm:bottom-auto sm:h-[2px] sm:w-auto" data-id="element-121" data-mp="19bp8r77r7tpm" />
          {steps.map((step, i) => {
          const Icon = stepIcons[i];
          return <li key={step.id} className="relative flex gap-4 border border-white/10 bg-navy-800/90 p-5 sm:flex-col sm:gap-0 sm:p-6" data-id="element-122" data-mp="31dk8tojiy7ji" data-mpi={i}>
                <span className="relative z-10 flex h-[52px] w-[52px] shrink-0 items-center justify-center border-2 border-brand-emerald/70 bg-navy-900 text-brand-emerald" aria-hidden="true" data-id="element-123" data-mp="3abvzfqke55by">
                  <Icon className="h-6 w-6" strokeWidth={2.25} data-id="element-124" data-mp="3ka3bpw3qiz7m" />
                </span>
                <div className="sm:mt-5" data-id="element-125" data-mp="3fb8ugylf1ipm">
                  <p className="font-pixel text-[10px] uppercase tracking-[0.16em] text-brand-gold" data-id="element-126" data-mp="3fca7v9pwmhai">
                    Step {step.index}
                  </p>
                  <h3 className="mt-2 font-pixel text-[11px] uppercase leading-relaxed tracking-[0.08em] text-white sm:text-xs" data-id="element-127" data-mp="1kx7mno7w1lde">
                    {step.title}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-slate-300" data-id="element-128" data-mp="3l1tm0a2wv0jf">
                    {step.copy}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <p className="mt-8 text-sm font-medium text-brand-cyan sm:text-base" data-id="element-129" data-mp="3u29kt68pljhy">
          Less time searching for activities. More time actually practicing.
        </p>
      </div>
    </section>;
}